import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'lib-question-hint',
    templateUrl: './question-hint.component.html',
    styleUrls: ['./question-hint.component.scss'],
    standalone: false
})
export class QuestionHintComponent implements OnInit {
  @Input() hint: string;

  constructor() { }

  ngOnInit(): void {
  }

}
